import { Button } from '@progress/kendo-react-buttons';
import { deleteSession, login } from '../../services/api.ts';
import styles from './auth-failed-render.module.scss';

export function AuthFailedRender() {
  const handleRetry = async () => {
    try {
      await deleteSession();
    } finally {
      sessionStorage.setItem('redirected', 'true');
      login(true);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={'/favicon.ico'} alt={'KORE'} />
        </div>
        <span className={styles.title}>Authentication Failed</span>
        <p className={styles.subtitle}>Unable to verify credentials with KORE</p>
        <Button themeColor={'primary'} className={styles.retryBtn} onClick={handleRetry}>
          Retry
        </Button>
      </div>
    </div>
  );
}
